var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13 15.5523 12.5523 16 12 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H12C12.5523 14 13 14.4477 13 15Z",
    fill: "#545E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 11.5523 0.447715 12 1 12H8C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10H1C0.447715 10 0 10.4477 0 11Z",
    fill: "#545E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 7.55229 5.55228 8 5 8H1C0.447715 8 0 7.55229 0 7C0 6.44771 0.447715 6 1 6H5C5.55228 6 6 6.44771 6 7Z",
    fill: "#545E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C3 3.55229 2.55228 4 2 4H1C0.447715 4 0 3.55229 0 3C0 2.44771 0.447715 2 1 2H2C2.55228 2 3 2.44771 3 3Z",
    fill: "#545E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C11 11.5523 11.4477 12 12 12C12.5523 12 13 11.5523 13 11V3.42435L14.2556 4.6967C14.6546 5.1011 15.3016 5.1011 15.7007 4.6967C16.0998 4.2923 16.0998 3.63663 15.7007 3.23223L12.8104 0.3033C12.5885 0.0784349 12.29 -0.0213947 12 0.00380993C11.71 -0.0213947 11.4115 0.0784349 11.1896 0.3033L8.2993 3.23223C7.90023 3.63663 7.90023 4.2923 8.2993 4.6967C8.69836 5.1011 9.34537 5.1011 9.74444 4.6967L11 3.42435V11Z",
    fill: "#545E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.694e87acf2fc13e36e572a91aa6cbfae.svg";
export { ForwardRef as ReactComponent };